import React, {forwardRef, useEffect, useLayoutEffect, useState} from 'react'
import ReactDOM from "react-dom"

import NavigationMenuItemUrl from "../../menu-items/menu-item-url"
import {ViewType} from "../../../../core/gd/const/views/view-type"

type Props = {
    className?  : string

    noAnimation : boolean
}

export default forwardRef(function MainMenu_MyTask(props: Props, ref: any) {

    const [animShow, setAnimShow] = useState(false)
    const [customView, setCustomView]   = useState(gd.session.customViews.getFirstByType(ViewType.MY_TASKS_LIST))

    useEffect(()=>{
        const animationDelay = _.delay(()=>{
            setAnimShow(true)
            const dom = ReactDOM.findDOMNode(ref.current)
            gd.utils.Dom.addClass(dom, 'anim-show')
        }, 50)

        return ()=>{
            clearTimeout(animationDelay)
        }
    }, [])

    const onChangeCustomView = () => {
        const newCustomView = gd.session.customViews.getFirstByType(ViewType.MY_TASKS_LIST)
        if (newCustomView) setCustomView(newCustomView)
    }

    useLayoutEffect(()=>{
        return gd.bus.subscribeNoContext('gd.session.customViews:change', onChangeCustomView)
    }, [])

    const classes = Classes('menu-my-tasks ui5-menu p-t-0', {
        'animation': gd.layout.shouldAnimateMenu && !props.noAnimation,
        'anim-show': animShow
    })

    const title             = customView?.name || 'My Tasks'
    const navigationSection = customView?.navigationSection

    return (
        <div className={classes} ref={ref}>
            <div className="ui5-app-controls v2 top-header">
                <div className="left txt-truncate">
                    <div className="ui5-title-app-name">{title}</div>
                </div>
            </div>

            <div className="ui5-menu m-t-10">
                <div className="menu-section open m-b-10">
                    <NavigationMenuItemUrl name                 = "Action required"
                                           navigationSection    = {navigationSection}
                                           icon                 = "i5-user-action-required"
                                           url                  = {'my-tasks/'+gd.const.myWork.viewType.ACTION_REQUIRED}/>

                    <NavigationMenuItemUrl name                 = "Assigned To Me"
                                           navigationSection    = {navigationSection}
                                           icon                 = "i5-user-assigned"
                                           url                  = {'my-tasks/'+gd.const.myWork.viewType.ASSIGNED_TO_ME}/>

                    <NavigationMenuItemUrl name                 = "Created by me"
                                           navigationSection    = {navigationSection}
                                           icon                 = "i5-user-created"
                                           url                  = {'my-tasks/'+gd.const.myWork.viewType.CREATED_BY_ME}/>

                    <NavigationMenuItemUrl name                 = "All involved in"
                                           navigationSection    = {navigationSection}
                                           icon                 = "i5-tasks"
                                           url                  = {'my-tasks/'+gd.const.myWork.viewType.ALL_INVOLVED}/>

                    <NavigationMenuItemUrl name                 = "Someday"
                                           navigationSection    = {navigationSection}
                                           icon                 = "i5-someday"
                                           url                  = {'my-tasks/'+gd.const.myWork.viewType.SOMEDAY}/>

                    <NavigationMenuItemUrl name                 = "Pastdue"
                                           navigationSection    = {navigationSection}
                                           icon                 = "i5-pastdue"
                                           url                  = {'my-tasks/'+gd.const.myWork.viewType.PASTDUE}/>
                </div>
            </div>
        </div>
    )
})
